import { render, staticRenderFns } from "./table-paginator.vue?vue&type=template&id=02b631b9&scoped=true"
import script from "./table-paginator.vue?vue&type=script&lang=js"
export * from "./table-paginator.vue?vue&type=script&lang=js"
import style0 from "./table-paginator.vue?vue&type=style&index=0&id=02b631b9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b631b9",
  null
  
)

export default component.exports